module.exports = __webpack_public_path__ + "img/ic_arrow_back_white.e943e7d5.svg";